
import { defineComponent } from "vue";
export default defineComponent({
  props: ["thumb", "btnLabel", "description"],
  methods: {
    onClick($event: Event) {
      this.$emit("btnClick", $event);
    },
  },
});
